import React from "react";

const Heading = ({ noFont = false, children, className = "", size = "textmd", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component className={`text-dark_blue_secondary ${noFont? "" : "font-poppins"} ${className}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Heading };
